import { render, staticRenderFns } from "./PolicyData.vue?vue&type=template&id=4374ac51&scoped=true"
import script from "./PolicyData.vue?vue&type=script&lang=js"
export * from "./PolicyData.vue?vue&type=script&lang=js"
import style0 from "./PolicyData.vue?vue&type=style&index=0&id=4374ac51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4374ac51",
  null
  
)

export default component.exports